import { Container } from "@mui/material";
import { makeStyles } from "@mui/styles";
import React from "react";
import { useTranslation } from "react-i18next";
import { siteColors } from "../../../common/config";
import { navRoutes } from "../../../common/routes";
import LangPanelContainer from "./LangPanel/LangPanelContainer";

const useStyles = makeStyles(() => ({
  wrapper: {
    borderBottom: "1px solid #ddd",
    padding: "1rem",
    "@media (max-width: 600px)": {
      display: "none",
    },
  },
  navItem: {
    marginLeft: "2rem",
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
    "@media (max-width: 600px)": {
      display: "block",
      textAlign: "center",
    },
  },
  navItemIcon: { marginRight: "0.4rem" },
  navItemTitle: {
    "@media (max-width: 600px)": { display: "block" },
  },
  link: {
    color: "#666",
    "&:hover": { color: siteColors?.main?.logo },
  },
  activeLink: { color: siteColors?.main?.logo },
}));

const HeadPanel = (props) => {
  const { t } = useTranslation();
  const classes = useStyles();

  const isExternal = (url) => /^https?:\/\//i.test(url ?? "");

  return (
    <div className={classes.wrapper}>
      <Container>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 2fr",
            gap: 16,
            alignItems: "center",
          }}
        >
          <div>
            <LangPanelContainer />
          </div>

          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              flexWrap: "wrap",
            }}
          >
            {navRoutes.map((route, index) => {
              const Comp = route?.component;
              const external = isExternal(route?.path);

              return (
                <Comp
                  key={route?.path}
                  to={route?.path}
                  onClick={route?.action}
                  className={classes.link}
                  {...(!external
                    ? { activeclassName: classes.activeLink }
                    : {})}
                >
                  <div
                    className={classes.navItem}
                    style={index === 0 ? { marginLeft: 0 } : undefined}
                  >
                    {route?.icon ? (
                      <route.icon className={classes.navItemIcon} />
                    ) : null}
                    <span className={classes.navItemTitle}>
                      {t(route?.title)}
                    </span>
                  </div>
                </Comp>
              );
            })}
          </div>
        </div>
      </Container>
    </div>
  );
};

export default HeadPanel;
